export default __webpack_public_path__ + "static/media/NR-BX421GUS02.ca8d8e34.jpg";